import { render, staticRenderFns } from "./TheOrganizationBusinessRoleList.vue?vue&type=template&id=4f9d8dc9&"
import script from "./TheOrganizationBusinessRoleList.vue?vue&type=script&lang=js&"
export * from "./TheOrganizationBusinessRoleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports